/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { SwitchBase } from "../SwitchBase";

import "./Switch.scss";

export interface ISwitchProps {
	className?: string;
	active?: boolean;
	disabled?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const Switch: React.FC<ISwitchProps> = ({ className, active, disabled, onChange }) => {
	const baseClass = BEM("edt-switch", null, {
		active,
		disabled
	});

	if (className) {
		baseClass.add(className);
	}

	const icon = <span className={baseClass.element("thumb-icon").toClassName()} />;

	return (
		<label className={baseClass.toClassName()}>
			<SwitchBase
				className={baseClass.element("thumb").toClassName()}
				type="checkbox"
				checked={active}
				icon={icon}
				onChange={onChange}
			/>
			<span className={baseClass.element("track").toClassName()} />
		</label>
	);
};

const SwitchMemo = React.memo(Switch);

export { SwitchMemo as Switch };
